import React from 'react';
import { connect } from 'react-redux';
import { withRouter, RouteComponentProps, Redirect } from 'react-router-dom';

import { ReduxState } from '../../../../redux/modules/types';
import DataProvider from '@/types/data-provider';

type StateProps = {
  oAuth2Provider?: DataProvider | null;
  oAuthRedirect?: string | null;
};

const mapStateToProps = (state: ReduxState) => ({
  oAuth2Provider: state.auth && state.auth.oAuth2Provider,
  oAuthRedirect: state.auth && state.auth.oAuthRedirect,
});

type Props = RouteComponentProps & StateProps;

const OAuth2 = (props: Props) => {
  const { oAuth2Provider, oAuthRedirect } = props;
  if (oAuth2Provider) {
    const redirectState = {
      name: oAuth2Provider.name,
      path: oAuthRedirect != null ? oAuthRedirect : '/',
    };
    const redirectUrl = `${oAuth2Provider.authorizeUrl}?response_type=code&client_id=${oAuth2Provider.clientId}&redirect_uri=${
      oAuth2Provider.redirectUri
    }&state=${JSON.stringify(redirectState)}`;
    window.location.href = redirectUrl;
    return null;
  }
  return <Redirect to="/" />;
};

export default withRouter(connect(mapStateToProps, {})(OAuth2));
